import { render, staticRenderFns } from "./SelfPublishingFlowQuoteFooterGutenberg.vue?vue&type=template&id=60631e1e&scoped=true&"
import script from "./SelfPublishingFlowQuoteFooterGutenberg.vue?vue&type=script&lang=js&"
export * from "./SelfPublishingFlowQuoteFooterGutenberg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60631e1e",
  null
  
)

export default component.exports